import React from "react";
import "./AudioPopup.css";
import { useMediaQuery } from "react-responsive";

export const AudioEnablePopup = ({ visible, onClick }) => {
  const isMobile = useMediaQuery({ maxWidth: 820 });
  if (!visible) return null;

  const handleTouch = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <div
      className="audio-enable-popup"
      onClick={onClick}
      onTouchStart={handleTouch}
    >
      <div className="audio-enable-content">
        <div className="audio-popup-text">
          This website uses audio for <span className="bold">a better experience</span>
        </div>
        {isMobile ? (
          <div className="audio-popup-instruction">
            Click anywhere to activate the sound
          </div>
        ) : (
          <div className="audio-popup-instruction">
            Click anywhere to activate the sound
          </div>
        )}
      </div>
    </div>
  );
};

export default AudioEnablePopup;